module.exports = { "default": require("core-js/library/fn/object/prevent-extensions"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/prevent-extensions.js
// module id = kBtn
// module chunks = 3